import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconQuestion = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				cx: 12,
				cy: 16.5,
				r: .9
			}),
			/* @__PURE__ */ _jsx("path", { d: "M12 3a9 9 0 100 18 9 9 0 000-18zm0 16.5a7.5 7.5 0 110-15 7.5 7.5 0 010 15z" }),
			/* @__PURE__ */ _jsx("path", { d: "M12 7.1a3 3 0 00-3 3v.8h1.5V10a1.5 1.5 0 111.5 1.5h-.8V15h1.6v-2a3 3 0 00-.8-5.9z" })
		]
	})
});
export { SvgIconQuestion as ReactComponent };
